var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightJetLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M16.55,14.057H9.894c-1.439,0-2.606-1.167-2.606-2.606V7.022c0-1.439,1.167-2.606,2.606-2.606h6.657 c1.439,0,2.606,1.167,2.606,2.606v4.429C19.157,12.89,17.99,14.057,16.55,14.057z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M12.474,4.417v-1.81c0-0.329,0.22-0.588,0.49-0.588h2.55c0.27,0,0.49,0.259,0.49,0.588v1.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M2.613,14.057L2.613,14.057c-0.977,0-1.77-0.792-1.77-1.77V3.789c0-0.977,0.792-1.77,1.77-1.77h0c0.977,0,1.77,0.792,1.77,1.77 v8.499C4.383,13.265,3.591,14.057,2.613,14.057z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.383,
    y: 6.656,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 2.904,
    height: 4.95
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 0.843,
    y1: 17.623,
    x2: 19.157,
    y2: 17.623
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 2.613,
    y1: 14.491,
    x2: 2.613,
    y2: 17.148
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.435,
    y1: 14.736,
    x2: 10.435,
    y2: 17.393
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 16.331,
    y1: 14.736,
    x2: 16.331,
    y2: 17.393
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightJetLift);
export default __webpack_public_path__ + "static/media/light-jet-lift.cd45bbdb4d4671451bf596a2c46b10e9.svg";
export { ForwardRef as ReactComponent };